var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDnk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 29,
    viewBox: "0 0 64 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M52.0486 14.4963L62.2328 0H52.4751L44.6294 11.0941V0H36.0752V10.5515H26.8736V0H4.2428V21.3082H0V29H26.8736L27.0183 18.4485H36.0676V29H44.5532V18.3752L53.2521 28.9927H64L52.0486 14.4963ZM18.3118 21.5062H12.797V7.88976H18.3118V21.5062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnk);
export default __webpack_public_path__ + "static/media/dnk.271c19a951e2d91b0e56bd4a3a937a86.svg";
export { ForwardRef as ReactComponent };